import { AutocompleteArrayInput, Link, ReferenceArrayInput, TextInput } from "react-admin";

const ProductSelectionFilter = (searchText: string) => {
  if (!searchText) return {};
  if (searchText.startsWith("prod_")) {
    return { productId__icontains: `${searchText}` };
  } else if (searchText.startsWith("price_")) {
    return { price_id__istartswith: `${searchText}` };
  }
  return {
    name__icontains: `${searchText}`,
  };
};

const ProductSelectionArrayInput = ({
  source = "products.productId",
  disabled = false,
  value = "",
  required = false,
}) => {
  return value ? (
    <TextInput source="" defaultValue={value} disabled />
  ) : (
    <ReferenceArrayInput
      label="Products"
      source={source}
      reference="v2Products"
      enableGetChoices={({ q }) => q && q.length >= 2}
      disabled={disabled}
      sx={{ width: "100%" }}
      isRequired={required}
    >
      <AutocompleteArrayInput
        label="Product"
        helperText="Lookup products by their name &amp; ID, or by price ID"
        optionText={(option) => {
          return (
            <>
              {option.name + " "} &nbsp;
              <Link to={`/v2Products/${option.id}/show`} target="_blank">
                {option.id} ↗
              </Link>
            </>
          );
        }}
        filterToQuery={ProductSelectionFilter}
        sx={{ width: "100%" }}
      />
    </ReferenceArrayInput>
  );
};

export default ProductSelectionArrayInput;
